import { createDataModule } from '@perpay-web/data-module/createDataModule';
import {
    updateCardAccountApplicationForOnboarding,
    updateCardAccountApplicationForOnboardingSuccess,
    updateCardAccountApplicationForOnboardingError,
    updateCardAccountApplicationForOnboardingReset,
} from '@perpay-web/fintech/actions/entities/cardAccountApplications';

const UpdateCardAccountApplicationForOnboardingDataModule = createDataModule({
    dataRequest: updateCardAccountApplicationForOnboarding,
    dataSuccess: updateCardAccountApplicationForOnboardingSuccess,
    dataError: updateCardAccountApplicationForOnboardingError,
    dataReset: updateCardAccountApplicationForOnboardingReset,
});

const getRoot = (state) =>
    state.dataModules.updateCardAccountApplicationForOnboarding;

const initialValue = {};

export const updateCardAccountApplicationForOnboardingDataModule =
    UpdateCardAccountApplicationForOnboardingDataModule({
        getRoot,
        initialValue,
    });
